import axios from "axios";
import roles from "../../models/autorizacion/roles";
import rolesId from "../../models/autorizacion/rolesId";
import operators from "../../models/autorizacion/operators";
import opersnrol from "../../models/autorizacion/operatorsSnRol";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getRoles() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/roles`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return roles.fromJson(item);
      });
    });
  }

  getRolesId(rol) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const rolid = rol.id;
    return axios.get(`${url}/roles/${rolid}`, { headers }).then(({ data }) => {
      return rolesId.fromJson(data);
    });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;
    payload = {
      nombre: data.nombre,
      descripcion: data.descripcion,
      asegurables: data.asegurables ? data.asegurables : undefined,
      operadores: data.operadores ? data.operadores : undefined,
      paInicioAsegId: data.initPage,
    };

    return axios.post(`${url}/roles`, payload, { headers });
  }

  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const rolid = data;

    return axios.delete(`${url}/roles/${rolid}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const rolid = data.rolId;

    let payload;

    payload = {
      nombre: data.nombre,
      descripcion: data.descripcion,
      asegurables: data.asegurables,
      operadores: data.operadores,
      paInicioAsegId: data.initPage,
    };

    return axios.patch(`${url}/roles/${rolid}`, payload, { headers });
  }

  getOperators() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/operadores`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return operators.fromJson(item);
      });
    });
  }

  getOpersnrol() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/roles/opersnrol`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return opersnrol.fromJson(item);
      });
    });
  }
}
export default service;
